import { FC } from "react";
import { TimeSlot } from "@/data/interfaces/Appointments";

type Props = {
  loading: boolean;
  error: string | null;
  selectedDate: Date | null;
  times: TimeSlot[] | null;
  selectedTime: TimeSlot | null;
  onSelectTime: (t: TimeSlot) => void;
};

const TimeSlots: FC<Props> = ({
  loading,
  error,
  selectedDate,
  times,
  selectedTime,
  onSelectTime,
}) => (
  <div className="w-full mt-4 pt-4 border-t border-gray-300">
    {loading && (
      <div className="text-gray-600 text-sm">Krauname galimus laikus…</div>
    )}
    {error && <div className="text-red-600 text-sm">{error}</div>}
    {!loading &&
      selectedDate &&
      Array.isArray(times) &&
      (() => {
        if (times.length === 0) {
          return (
            <div className="text-gray-600 text-sm">
              Laisvų laikų nėra, pasirinkite kitą dieną.
            </div>
          );
        }

        return (
          <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
            {times.map((slot) => (
              <button
                type="button"
                key={slot.show}
                onClick={() => onSelectTime(slot)}
                className={[
                  "text-sm font-medium px-3 py-2 rounded-md transition",
                  "border border-gray-200",
                  "cursor-pointer bg-white text-ink hover:bg-accent hover:text-white",
                  selectedTime?.value === slot.value
                    ? "!bg-accent !text-white border-transparent"
                    : "",
                ].join(" ")}
              >
                {slot.show}
              </button>
            ))}
          </div>
        );
      })()}
  </div>
);

export default TimeSlots;
